'use client';

import STAFF from '@/app/config/staff'
import MemberOverlay from '../member-overlay'
import RenderInView from '@/app/(site)/components/render-in-view'

const StaffGrid = () => {
    return (
        <div className="pb-10">
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-1.5">
                {STAFF.map(member => (
                    <div key={member.name} className="relative group">
                        <div
                            key={member.name}
                            className="bg-[#1C1C1C] w-full aspect-square"
                        >
                            <img
                                alt={member.name}
                                src={member.gif}
                                className="w-full h-full object-cover"
                            />
                        </div>

                        <MemberOverlay member={member} />
                    </div>
                ))}
            </div>
            
            <RenderInView>
                <div className="py-1.5 mx-auto flex animate-fade-in flex-col items-center text-white">
                    <div>
                        Questions? Feedback? Visit our <a href="https://support.giphy.com">Help Center</a>
                    </div>
                    <div>
                        GIFs by <a href="/csak">Csaba Klement</a>
                    </div>
                </div>
            </RenderInView>
        </div>
    )
}

export default StaffGrid
